import { Route, Switch } from 'react-router-dom';

import {
  LinkedinAuthContainer,
  TwitterAuthContainer,
} from 'components/ShareToSocialMedia/authcontainer';
import UnauthenticatedRoute from 'containers/UnauthenticatedRoute';
import UserUpdatePasswordContainer from 'containers/userupdatepassword';
import { NetworkRequestStatusProvider } from 'context/networkRequestStatusContext';
import SubmitReferenceContainer from 'features/SubmitReference';
import SubmitScorecardContainer from 'features/SubmitScorecard/submitscorecard';
import JobsListContainer from '../../containers/jobslist';
import JobviewContainer from 'containers/JobviewContainer';
import LoginContainer from '../../containers/login';
import LoginHandoff from '../Login/LoginHandoff';
import HellosignEmbeddedSigning from '../../features/HellosignEmbeddedSigning';
import StateJobBoard from '../../features/StateJobBoard';
import PublicRoute from '../PublicRoute';
import SocialMediaTrackingContainer from '../ShareToSocialMedia/trackingcontainer';

interface PublicRoutesProps {
  fallback: React.ReactNode;
}

const PublicRoutes: React.FC<PublicRoutesProps> = ({ fallback }) => {
  return (
    <Switch>
      <PublicRoute path="/jobs/state/:id">
        <StateJobBoard />
      </PublicRoute>
      <PublicRoute path="/jobs/:id">
        <NetworkRequestStatusProvider>
          <JobsListContainer />
        </NetworkRequestStatusProvider>
      </PublicRoute>
      <PublicRoute
        path="/hellosign-embedded-sign/:signatureid"
        component={HellosignEmbeddedSigning}
      />
      <PublicRoute path="/jobview/:id" component={JobviewContainer} />
      {/* Broken on prod too? */}
      <Route path="/j/:code">
        <SocialMediaTrackingContainer />
      </Route>
      <PublicRoute path="/scorecard">
        <SubmitScorecardContainer />
      </PublicRoute>
      <Route path="/reference">
        <SubmitReferenceContainer />
      </Route>
      <PublicRoute path="/socialmedia/auth/linkedin">
        <LinkedinAuthContainer />
      </PublicRoute>
      <PublicRoute path="/socialmedia/auth/twitter">
        <TwitterAuthContainer />
      </PublicRoute>
      <PublicRoute path="/password_reset">
        <UserUpdatePasswordContainer />
      </PublicRoute>
      {/* ================== */}
      <UnauthenticatedRoute path="/login/password">
        <LoginContainer passwordOnly />
      </UnauthenticatedRoute>
      <UnauthenticatedRoute path="/login">
        <LoginHandoff />
      </UnauthenticatedRoute>
      <Route path="*">{fallback}</Route>
    </Switch>
  );
};

export default PublicRoutes;
